import { createReducer, on } from '@ngrx/store';
import { ProductManager } from '@shared/interfaces/product-manager/product-manager.interface';

import { productManager } from './product-managers.actions';

export const productManagerFeatureKey = 'productManager';

export interface ProductManagersState {
  productManagers: Array<ProductManager>;
  loading: boolean;
}

export const initialState: ProductManagersState = {
  productManagers: [],
  loading: false
};

export const productManagersReducer = createReducer<ProductManagersState>(
  initialState,
  on(productManager.load, (state: ProductManagersState) => ({
    ...state,
    loading: true
  })),
  on(
    productManager.loadSuccess,
    (state: ProductManagersState, data: { productManagers: Array<ProductManager> }) => ({
      ...state,
      productManagers: data.productManagers,
      loading: false
    })
  )
);
